<template>
  <div class="tipo">
    <div class="centro">
      <h1><span>Consulta por Ordem Cronológica</span></h1>
      <BuscaSimplesCards titulo="Consultas Rápidas" :cards="cards" />
      <Loading v-if="carregando" />
      <ErroResultados v-if="!carregando && erro" />
      <PainelAnos
        v-if="!carregando && !erro"
        :anos="anos"
        :generateUrl="generateUrl"
      />
    </div>
  </div>
</template>

<script>
import LegislacaoMunicipalApi from "@/services/LegislacaoMunicipalApi";
import Loading from "@/components/Loading";
import ErroResultados from "@/components/ErroResultados";
import PainelAnos from "@/components/PainelAnos";
import BuscaSimplesCards from "@/components/BuscaSimplesCards.vue";

export default {
  name: "MensagensVetoPorEnteFederativoPorAno",
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      carregando: true,
      erro: false,
      anos: [],
      enteFederativoId: null,
    };
  },
  components: {
    Loading,
    ErroResultados,
    PainelAnos,
    BuscaSimplesCards,
  },
  created() {
    this.legislacaoApi = new LegislacaoMunicipalApi();
    this.findEnteFederativoAndLoadAnos();
  },
  methods: {
    findEnteFederativoAndLoadAnos: async function () {
      try {
        const allEntesFederativos = await this.legislacaoApi.getEntesFederativos();
        const enteFederativo = allEntesFederativos.find(ente => ente.slug === this.slug);

        if (!enteFederativo) {
          this.erro = true;
          this.carregando = false;
          return;
        }
        this.enteFederativoId = enteFederativo.id;
        this.carregarAnos();
      } catch (err) {
        console.log("findEnteFederativoAndLoadAnos", err);
        this.erro = true;
        this.carregando = false;
      }
    },
    carregarAnos: async function () {
      try {
        if (this.legislacaoApi.cancelTokens.getAnosMensagensVeto) {
          this.legislacaoApi.cancelTokens.getAnosMensagensVeto.cancel();
        }

        this.carregando = true;
        this.erro = false;
        this.anos = await this.legislacaoApi.getAnosMensagensVeto(this.enteFederativoId);
        this.carregando = false;
      } catch (err) {
        if (this.legislacaoApi.isCancel(err)) {
          return;
        }
        console.log(err);
        this.erro = true;
        this.carregando = false;
      }
    },
    generateUrl: function (ano) {
      return { name: "MensagensVetoPorEnteFederativo", params: { slug: this.slug }, query: { ano, busca_avancada: 1 } };
    },
  },
  computed: {
    cards() {
      return [
        {
          rota: { name: "MensagensVetoPorEnteFederativoPorTipoLegislacao", params: { slug: this.slug } },
          icone: require("@/assets/images/icon-tipo-legislacao2.png"),
          iconeClasse: "legisla-icon",
          titulo: "Tipo de Legislação",
          descricao: "Consulte as Mensagens de Veto<br /> por <strong>tipo de legislação</strong>",
        },
        {
          rota: { name: "MensagensVetoPorEnteFederativoPorTipoVeto", params: { slug: this.slug } },
          icone: require("@/assets/images/icon-tipo-veto2.png"),
          iconeClasse: "legisla-icon",
          titulo: "Tipo de Veto",
          descricao: "Consulte as Mensagens de Veto<br /> por <strong>tipo</strong>",
        },
        {
          rota: { name: "MensagensVetoPorEnteFederativoPorAno", params: { slug: this.slug } },
          icone: require("@/assets/images/icon-indice-cronologico2.png"),
          iconeClasse: "indice-icon",
          titulo: "Índice Cronológico",
          descricao: "Consulte as Mensagens de Veto<br /> por <strong>ano</strong>",
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
h1 span{
   background-color: #ffb24e;
  width: fit-content;
  border-radius: 12px;
  color: #0e489f;
  font-size: 1.5rem;
  padding: 0 0.3rem;
  margin: 2rem 0rem 1.5rem 0.5rem;
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;/* limita o fundo ao tamanho do texto */
}
.tipo {
  min-height: calc(100vh - 10rem);
  margin-bottom: 5rem;
}
</style>
